import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Link } from '@material-ui/core';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

interface OrdersTableProps {
  orders: any[];
}

const createLink = (orderNode: any) => {
  const gid = orderNode.id.split('/').pop();
  return `/order/${gid}`;
};

const OrdersTable: FC<OrdersTableProps> = (props) => {
  const classes = useStyles();
  return (
    <TableContainer>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Name</TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell align="center">Date</TableCell>
            <TableCell align="center">Open</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.orders?.map((order) => (
            <TableRow key={order.node.name}>
              <TableCell component="th" scope="row">
                {order.node.name}
              </TableCell>
              <TableCell align="center">{order.node.displayFulfillmentStatus}</TableCell>
              <TableCell align="center">{order.node.createdAt}</TableCell>
              <TableCell align="center">
                <Link href={createLink(order.node)}>
                  Open
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OrdersTable;
